const isPaymentMethodValid = (paymentMethod) => {
  if (!paymentMethod) return false;
  if (paymentMethod.type === "paypal") return true;
  if (paymentMethod.type === "sepa_debit") return true;

  const { exp_year: expYear, exp_month: expMonth } = paymentMethod;
  const expiracyDate = new Date(expYear, expMonth, 0);
  const now = new Date();
  if (now < expiracyDate) return true;

  return false;
};

export default isPaymentMethodValid;
